// extracted by mini-css-extract-plugin
module.exports = {"count":"desktop_type_item_count-module__count--1KL4A","plus":"desktop_type_item_count-module__plus--2iJFf"};